import type { FC, ReactNode } from 'react';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { MoreHorizontal } from 'lucide-react';

export type IpcRowActionItem = {
  key: string;
  label: ReactNode;
  danger?: boolean;
  onClick?: () => void;
};

type Props = {
  actions: IpcRowActionItem[];
  moreLabel?: string;
  maxVisible?: number;
};

/** Table row text actions. Extra actions are collected under "more". */
export const IpcRowActions: FC<Props> = ({ actions, moreLabel = '更多', maxVisible = 3 }) => {
  if (actions.length === 0) return null;

  const visible = actions.slice(0, maxVisible);
  const overflow = actions.slice(maxVisible);

  const menuItems: MenuProps['items'] = overflow.map(item => ({
    key: item.key,
    label: item.label,
    danger: item.danger,
    onClick: () => item.onClick?.(),
  }));

  return (
    <div className="ipc-row-actions">
      {visible.map(item => (
        <button
          key={item.key}
          type="button"
          className={`ipc-row-action${item.danger ? ' ipc-row-action--danger' : ''}`}
          onClick={item.onClick}
        >
          {item.label}
        </button>
      ))}
      {overflow.length > 0 && (
        <Dropdown menu={{ items: menuItems }} trigger={['click']}>
          <button type="button" className="ipc-row-action">
            {moreLabel}
            <MoreHorizontal size={14} aria-hidden />
          </button>
        </Dropdown>
      )}
    </div>
  );
};
